class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.init = false;
    this.$gridContainer = this.querySelector("[data-grid]");
    this.$gridToggle = document.querySelector("product-grid-size-toggle");
    this.currentGridSize = this.gridSizeFromSession;
    this.init = true;
  }

  get gridSizeFromSession() {
    return sessionStorage.getItem("gridSize") || "product-grid-4";
  }

  set gridSizeFromSession(gridSize) {
    this.currentGridSize = gridSize;
    sessionStorage.setItem("gridSize", gridSize);
  }

  setGridSize(gridSize) {
    this.$gridContainer.setAttribute("class", gridSize);
    this.$gridToggle.currentGridSize = gridSize;
    $("[data-product-images-slideshow]").each(function (index, slideshow) {
      if ($(slideshow).hasClass('slick-initialized')) {
        $(slideshow).slick("setPosition");
      }
    });
  }

  set currentGridSize(gridSize) {
    switch (gridSize) {
      case "product-grid-2":
        this.setGridSize(gridSize);
        break;
      default:
        this.setGridSize("product-grid-4");
    }
  }
}

customElements.define("product-grid", ProductGrid);
